export default "__VITE_ASSET__a0bc14d7__"